import { useState } from "react";
import { Archive, Loader2 } from "lucide-react";

export default function ResumeArchive({ reasons, busy, hasNext, onConfirm }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(reasons.includes("Lacks experience") ? "Lacks experience" : reasons[0] || "");
  const [note, setNote] = useState("");

  if (!open) {
    return (
      <button data-testid="resume-archive-open" disabled={busy} onClick={() => setOpen(true)}
        className="w-full flex items-center justify-center gap-1.5 px-3 py-2 rounded-md border border-[#b91c1c]/30 text-[#b91c1c] text-sm font-bold hover:bg-[#b91c1c]/5 disabled:opacity-60 transition-colors">
        <Archive className="h-4 w-4" /> Not a fit — archive
      </button>
    );
  }

  return (
    <div data-testid="resume-archive-box" className="rounded-md border border-[#b91c1c]/30 bg-[#b91c1c]/5 p-3 space-y-2 animate-in fade-in slide-in-from-bottom-1 duration-150">
      <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#b91c1c]">Archive as not a fit</div>
      <select data-testid="resume-archive-reason" value={reason} onChange={(e) => setReason(e.target.value)}
        className="w-full rounded-md border border-[#15233B]/15 bg-white px-2 py-1.5 text-sm text-[#15233B]">
        {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <textarea data-testid="resume-archive-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2}
        placeholder="Optional note (no PHI)" className="w-full rounded-md border border-[#15233B]/15 bg-white px-2 py-1.5 text-sm text-[#15233B] resize-none" />
      <div className="flex gap-2">
        <button data-testid="resume-archive-cancel" type="button" disabled={busy} onClick={() => setOpen(false)}
          className="flex-1 px-3 py-2 rounded-md border border-[#15233B]/15 text-sm font-bold text-[#15233B]/70 hover:bg-white">Cancel</button>
        <button data-testid="resume-archive-confirm" type="button" disabled={busy || !reason} onClick={() => onConfirm(reason, note.trim())}
          className="flex-[2] flex items-center justify-center gap-1.5 px-3 py-2 rounded-md bg-[#b91c1c] text-white text-sm font-extrabold hover:bg-[#991b1b] disabled:opacity-60 transition-colors">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} {hasNext ? "Archive & next" : "Archive"}
        </button>
      </div>
    </div>
  );
}
